module.exports = __webpack_public_path__ + "img/21.3eec07c5.jpg";